import type { ScheduleModel } from 'entities/campaign';
import { addSpaceToSchedule, convertTo24, getMinutesFromDate, getTimeRanges } from 'shared/lib/time-ranges';
import type { Timezone } from 'shared/lib/timezones';
import { useCallback } from 'react';

import { useGetCallCenterRestrictionTimeRange } from '../api';

type HookParams = {
  timeZone: Timezone;
};

type TimeOptions = {
  text: string;
  id: string;
}[];

const TIME_RANGE = 30;

export const useGetScheduleTimeRange = ({ timeZone }: HookParams) => {
  const scheduleData = useGetCallCenterRestrictionTimeRange(timeZone);
  const scheduleRestriction = scheduleData.data?.data;

  const getTimeOptions = useCallback(
    (day: keyof ScheduleModel) => {
      let timeOptions: TimeOptions = [];

      if (scheduleRestriction) {
        const dayRestrictions = scheduleRestriction[day];
        const fromRestriction24 = convertTo24(dayRestrictions.timeFrom);
        const toRestriction24 = convertTo24(dayRestrictions.timeTo);

        const fromRestrictionMinutes = getMinutesFromDate({
          hours: fromRestriction24.hours,
          minutes: fromRestriction24.minutes,
        });

        const toRestrictionMinutes = getMinutesFromDate({
          hours: toRestriction24.hours,
          minutes: toRestriction24.minutes,
        });

        timeOptions = getTimeRanges(TIME_RANGE, {
          fromMinutes: fromRestrictionMinutes,
          toMinutes: toRestrictionMinutes + 30,
        }).map((time) => ({
          text: addSpaceToSchedule(time),
          id: time,
        }));
      } else {
        timeOptions = getTimeRanges(TIME_RANGE).map((time) => ({
          text: addSpaceToSchedule(time),
          id: time,
        }));
      }

      return timeOptions;
    },
    [scheduleRestriction]
  );

  return { getTimeOptions, isLoading: scheduleData.isFetching };
};
